import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle } from 'lucide-react';
const reasons = [{
  title: 'Juegos comunes',
  desc: 'Los sudokus y crucigramas comunes no son suficientes porque el cerebro se acostumbra rápido a ellos y deja de esforzarse.'
}, {
  title: 'Aplicaciones complejas',
  desc: 'Las aplicaciones de entrenamiento mental suelen ser complejas, tecnológicas y están diseñadas en inglés, creando más estrés que soluciones.'
}, {
  title: 'Consejos genéricos',
  desc: "Los consejos médicos genéricos de 'coma sano y camine' no le dan las herramientas prácticas para fortalecer la memoria inmediata ahora mismo."
}, {
  title: 'Esperar lo mejor',
  desc: "Confiar solo en la 'suerte' genética es una estrategia arriesgada cuando su independencia está en juego."
}];
export function WhyDidntWork() {
  return <section className="bg-white py-20 md:py-28 px-6" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="text-center mb-16" data-id="element-195">
            <h2 className="font-serif text-3xl md:text-4xl text-navy-900 font-bold mb-4" data-id="element-196">
              Por qué lo que ha intentado no funciona
            </h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto rounded-full" data-id="element-197"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-198">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-199">
              <div className="bg-cream-50 rounded-2xl p-8 h-full border border-cream-200 hover:shadow-md transition-shadow" data-id="element-200">
                <div className="flex items-start gap-4" data-id="element-201">
                  <XCircle className="w-8 h-8 text-red-400/80 shrink-0 mt-1" data-id="element-202" />
                  <div data-id="element-203">
                    <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-204">
                      {reason.title}
                    </h3>
                    <p className="text-lg text-charcoal-700 leading-relaxed" data-id="element-205">
                      {reason.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}